enum routingTestIds {
	searchHeaderId = 'search_results_header',
}

export default routingTestIds;
